<template>
<div>
 <card :title="card.title" :subTitle="card.subTitle">
     <div id="cardbody">
    <div class="map-container">
     <GmapMap
          v-bind:center="center"
          :zoom="12"

          v-bind:map-type-id="mapTypeId"
           style="width: 100%; height: 100%; position: relative; ">
          <GmapMarker
            v-for="(item, index) in markers"
            :key="index"
            v-bind:position="item.position"
            @click="pushLocationCard(index, item.position, item.name, item.strasse, item.hausnummer, item.plz, item.stadt, item.telefon)">
             <gmap-info-window
                
                  :opened="item.opened"
                  
                  @closeclick="item.opened=false">
            <div id="content">
              <div id="siteNotice">                    
              </div>

              <b>{{item.name}}</b>
              <div id="bodyContent">
                <p> {{item.strasse}}  {{item.hausnummer}} <br>
                {{item.plz}} {{item.stadt}} 
                </p>

                <v-btn fab dark color="blue" v-on:click="gotoMaps(item.strasse, item.hausnummer, item.plz, item.stadt);">
                        <v-icon id="icons" dark>navigation</v-icon>
                </v-btn>
                <v-btn fab dark color="green" v-bind:href="'tel:' + item.telefon">
                        <v-icon id="phone" dark>phone</v-icon>
                </v-btn>
              
              
              </div>
            </div>

        </gmap-info-window>
          </GmapMarker>
          <!-- <gmap-info-window
                :options="infoOptions"
                :position="infoPosition"
                :opened="infoOpened"
                :content="infoContent"
                @closeclick="infoOpened=false">
               

        </gmap-info-window>
         -->
          </GmapMap>
          </div>
    </div>
</card>
        

</div>
</template>

<script>
  export default {
    data() {
      return {
        card :{
            title: "Kunden des Tages",
            subTitle: "Folgende Kunden konnten nicht angezeigt werden:"
        },
        center: { lat: 51.399060, lng: 7.187600 },
        mapTypeId: "terrain",
        markers: [
            
        ],
        plz: [],
        strasse: [],
        hausnummer: [],
        stadt: [],
        name: [],
        telefon: [],
        noValidAdresses: [],
        stat: [],
        infoPosition: { lat: 51.399060, lng: 7.187600 },
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      iinfoOptions: {
        pixelOffset: {
          width: 0,
          height: 0
        },
        content: ''
      }
      }
    },
    methods:{
        gotoMaps(Strasse, Hausnummer, PLZ, Stadt) {
     
          window.location.href = "https://www.google.com/maps/dir/?api=1&destination=" + Strasse + "+"+ Hausnummer+ "+"+PLZ+"+" + Stadt+ "+Germany&travelmode=driving";
        },
        pushLocationCard: function(index, position, name, strasse, hausnummer, plz, stadt, telefon){
            for(var i = 0; i< this.markers.length; i++){
              this.markers[i].opened = false;
            }
            this.center = position;
            console.log(name)
            // this.infoOptions.content =  
            // '<div id="content">'+
            // '<div id="siteNotice">'+
            // '</div>'+
            // '<h3 id="firstHeading" class="firstHeading">'+ name +'</h3>'+
            // '<div id="bodyContent">'+
            // '<p>'+ strasse + ' '+ hausnummer + '<br>'+
            // plz + ' ' + stadt + '<br>'+
            // 'Telefon: ' + telefon +'<br>'+
            // '<button onclick="this.test()">Click me</button>'+
            
            // '</div>'+
            // '</div>'
           
            // this.infoOpened = true; 
            this.markers[index].opened = true
        },
        test(){
          console.log('blub')
        },
        fetchAdresses(name, i){
            // for(var i = 0; i<this.stadt.length; i++){
            if(this.stat[i] == 1){
              this.$http
              .get("https://nominatim.openstreetmap.org/search?postalcode="+this.plz[i]+"&city="+this.stadt[i]+"&street="+this.hausnummer[i]+" "+this.strasse[i]+"&format=json")
              .then(function(response) {
                  // console.log(response);
                  if(response.body.length > 0){
                  let newmarker = {
                      position: { lat: parseFloat(response.body[0].lat), lng: parseFloat(response.body[0].lon) }, name: name[i], strasse: this.strasse[i], hausnummer: this.hausnummer[i], plz: this.plz[i], stadt: this.stadt[i], telefon: this.telefon[i], opened: false
                  }
                  console.log(newmarker)
                  this.markers.push(newmarker)
                  }else{
                      this.noValidAdresses.push(i)
                      this.card.subTitle += " " + name[i] + " ("+ this.strasse[i] + " " + this.hausnummer[i] +") |"
                  }
              });
            }
            
            // }
            console.log(this.noValidAdresses)
            // for(var i = 0; i< this.markers.length; i++){
            //     // this.markers[i].name = this.name[i];
            //     console.log(this.name[i])
            // }
        },
        createToday(){
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            var date = yyyy+ '-' + mm + '-' + dd;
            return date;
        },
        fetchBestellungen() {
      
        var date = this.createToday();
        console.log(date)
        //Date ÄNDERN!!
        this.$http
            .post(process.env.VUE_APP_PHP_API_URL+"/bestellungen/"+ date, {auth: process.env.VUE_APP_PHP_AUTH})
            .then(function(response) {
            var names = [];
            for (var i =0; i< response.body.length; i++){
                this.strasse.push(response.body[i].Strasse);
                this.plz.push(response.body[i].PLZ);
                this.stadt.push(response.body[i].Stadt);
                this.hausnummer.push(response.body[i].Hausnummer);
                this.stat.push(response.body[i].stat);
                if (response.body[i].Firma.length < 2) {
                    names.push(response.body[i].Nachname);
                }
                else{
                    names.push(response.body[i].Firma);
                }
                this.telefon.push(response.body[i].Telefon);
            
            }
            console.log(names)
            for(var i = 0; i<this.stadt.length; i++){
            this.fetchAdresses(names, i);
            }
        });
    },
    },
    created: function() {
        this.fetchBestellungen();
    }
  }
</script>
<style scoped>

  .map-container {
    width: 100%;
    height: 580px;
  }
  #cardbody{
      padding:0%;

  }
  .knopf{
    background-color: pink;
  }
  #phone{
    padding-left: 15px;
    padding-top: 15px;
  }
  @media (min-device-width: 961px) {
    #icons{
      padding-top: 15px;
    }
  }
</style>
